import React from 'react';
import { Link } from 'react-router-dom';
import Image404 from '../../../shared/img/404/404.png';

const NotFound404 = () => (
  <div className="not-found">
    <div className="not-found__content">
      <img className="not-found__image" src={Image404} alt="404" />
      <h3 className="not-found__info">No se encontró la página solicitada</h3>
      <Link className="btn btn-primary" to="/">Volver al inicio de sesión</Link>
    </div>
  </div>
);

export default NotFound404;
